const EXACT_ID = /^[a-z][a-z0-9-]*$/;

function exactSegment(value: string, label: string): string {
  if (!EXACT_ID.test(value)) {
    throw new Error(`${label} is not an admitted exact identifier: ${value}`);
  }
  return value;
}

export function applicationNamespace(
  applicationBlueprintId: string,
  applicationInstanceId: string,
): string {
  return `cogo://application-blueprint/${exactSegment(
    applicationBlueprintId,
    "applicationBlueprintId",
  )}/${exactSegment(applicationInstanceId, "applicationInstanceId")}`;
}

export function uxInstanceNamespace(
  applicationNamespaceId: string,
  uxInstanceId: string,
): string {
  return `${applicationNamespaceId}/ux/${exactSegment(
    uxInstanceId,
    "uxInstanceId",
  )}`;
}

export function pageNamespace(
  uxInstanceNamespaceId: string,
  pageId: string,
): string {
  return `${uxInstanceNamespaceId}/page/${exactSegment(pageId, "pageId")}`;
}

export function blockNamespace(
  pageNamespaceId: string,
  blockId: string,
): string {
  return `${pageNamespaceId}/block/${exactSegment(blockId, "blockId")}`;
}

export function blockActionId(
  blockNamespaceId: string,
  actionId: string,
): string {
  return `${blockNamespaceId}/action/${exactSegment(actionId, "actionId")}`;
}

export function exactResourceId(
  namespaceId: string,
  kind:
    | "state"
    | "event"
    | "flow"
    | "datasource"
    | "port"
    | "node"
    | "action"
    | "result"
    | "journey-step",
  localId: string,
): string {
  return `${namespaceId}#${kind}/${exactSegment(localId, `${kind}Id`)}`;
}
